import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function Spinner({ className }) {
  return <Loader2 className={cn("animate-spin", className)} />;
}

export function Loading({ label = "Laddar…", className }) {
  return (
    <div
      data-testid="loading-state"
      className={cn("flex items-center justify-center gap-3 py-16 text-muted-foreground", className)}
    >
      <Spinner className="h-5 w-5" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function Skeleton({ className }) {
  return <div className={cn("skeleton", className)} />;
}

// Modern, consistent table loading skeleton that mirrors the coming layout.
export function TableSkeleton({ rows = 6, cols = 4 }) {
  return (
    <div data-testid="table-skeleton">
      <div className="flex gap-4 border-b border-border bg-muted/40 px-3 py-3.5">
        {Array.from({ length: cols }).map((_, i) => (
          <Skeleton key={i} className="h-3 flex-1" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex items-center gap-4 border-b border-border/60 px-3 py-4" style={{ opacity: Math.max(0.35, 1 - r * 0.09) }}>
          {Array.from({ length: cols }).map((_, i) => (
            <Skeleton key={i} className={cn("h-4 flex-1", i === 0 && "max-w-[40%]")} />
          ))}
        </div>
      ))}
    </div>
  );
}
